import sdl from '@jds/react-generated-sdl/JDSFooterMarketLinks';
import type { JDSFooterMarketLinksProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFooterMarketLinksProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSFooterMarketLinks',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FooterMarketLinks = withLogic(
  Component
) as React.FC<JDSFooterMarketLinksProps> & { slotName?: string };

FooterMarketLinks.displayName = 'FooterMarketLinks';
FooterMarketLinks.slotName = 'jds_footer_market_links';

export { FooterMarketLinks, type JDSFooterMarketLinksProps };
